import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Button from '../Button';
import { RefreshIcon } from './styled';

const RefreshButton = ({ onClick, dataTestId = undefined }) => {
  const intl = useIntl();

  return (
    <Button
      variant="ghost"
      startIcon={ <RefreshIcon /> }
      ariaLabel={ intl.formatMessage({ id: 'common.components.button.refresh' }) }
      onClick={ onClick }
      data-testid={ dataTestId }
    />
  );
};

RefreshButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  dataTestId: PropTypes.string
};

export default RefreshButton;
